<template>
  <div class="tab-pane fade show active" role="tabpanel">
    <InvoiceManagementComponent
      v-if="company.id"
      :company="company"
      :isAdmin="isAdmin"
      :pendingInvoiceItems="pendingInvoiceItems"
      :defaultInvoiceNumber="defaultInvoiceNumber"
      :initialTab
      @invoice-requested="$emit('invoice-requested')"
    />
  </div>
</template>

<script setup lang="ts">
import InvoiceManagementComponent from "@/dashboard/invoice_management/InvoiceManagementComponent.vue";
import type { Company, InvoiceItem } from "@/types";

defineEmits<{
  "invoice-requested": [];
}>();

defineProps<{
  company: Company;
  isAdmin: boolean;
  pendingInvoiceItems: InvoiceItem[];
  defaultInvoiceNumber: string;
  initialTab: string;
}>();
</script>
